import React from 'react';

import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {formatMasks} from 'presentation/utils/formatMasks';
import Icon from 'presentation/icons';
import {partialHiddenEmail} from 'presentation/utils';
import {ContactDataListProps} from './types';

export function ContactDataList({email, phoneNumber}: ContactDataListProps) {
	return (
		<List>
			<ListItem>
				<ListItemIcon>
					<Icon name="ben-mail-outline-filled" />
				</ListItemIcon>
				<ListItemText primary={partialHiddenEmail(email)} />
			</ListItem>
			<Divider />
			<ListItem>
				<ListItemIcon>
					<Icon name="phone-android-filled" />
				</ListItemIcon>
				<ListItemText primary={formatMasks('hidePhone', phoneNumber)} />
			</ListItem>
		</List>
	);
}
